import React from 'react';
import { trackAddToCart } from '../utils/metaPixel';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  href?: string;
}
export function Button({
  children,
  onClick,
  className = '',
  href
}: ButtonProps) {
  const classes = `bg-[#C9A84C] hover:bg-[#b89842] text-gray-900 font-semibold py-4 px-8 rounded-full shadow-md transition-all transform hover:-translate-y-1 active:translate-y-0 text-lg md:text-xl w-full md:w-auto text-center flex items-center justify-center gap-2 ${className}`;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={classes} onClick={() => trackAddToCart()} data-id="element-1">
        {children}
      </a>;
  }
  return <button onClick={onClick} className={classes} data-id="element-2">
      {children}
    </button>;
}